export default __webpack_public_path__ + "static/media/youtube_icon.4e1dc607.svg";